import { SwapOutlined } from '@ant-design/icons';
import { Card, Timeline, Typography } from 'antd';
import moment from 'moment';
import { Trans } from 'react-i18next';

interface ApplicantStageMovimentationTimelineProps {
  recruiterName: string;
  createdDate: string;
  fromStage: string;
  toStage: string;
  opportunityTitle: string;
}

const ApplicantStageMovimentationTimeline = ({
  recruiterName,
  createdDate,
  fromStage,
  opportunityTitle,
  toStage,
}: ApplicantStageMovimentationTimelineProps) => {
  return (
    <Timeline.Item dot={<SwapOutlined />}>
      <Card>
        <Typography.Paragraph>
          <Typography.Text type="secondary">{moment(createdDate).format('LLL')}</Typography.Text>
          <br />
          <Typography.Text>
            <Typography.Text strong>{recruiterName} </Typography.Text>
            <Trans>movimentou o(a) candidato(a) da etapa</Trans>{' '}
            <Typography.Text strong>{fromStage}</Typography.Text> <Trans>para a etapa</Trans>{' '}
            <Typography.Text strong>{toStage}</Typography.Text> <Trans>na vaga</Trans>{' '}
            <Typography.Text strong>{opportunityTitle}</Typography.Text>
          </Typography.Text>
        </Typography.Paragraph>
      </Card>
    </Timeline.Item>
  );
};

export default ApplicantStageMovimentationTimeline;
